<script setup lang="ts">
import type { IProps } from './career-main-boxThreeOnRow.types'
import CareerBox from '~/domains/career/main/components/career-main-box/career-main-box.vue'
defineProps<IProps>()

</script>

<template>
  <div class="ui-box-three-on-row">
    <h6 class="ui-box-three-on-row__title">
      {{ title }}
    </h6>

    <div class="ui-box-three-on-row__flexbox">
      <CareerBox
        v-for="(box, index) in boxes"
        :key="index"
        v-bind="box"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-box-three-on-row {
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: $gray-100;

  &__title {
    @include h5;
    padding: 0 2.5rem 3.2rem;
    color: $text-400;
    text-align: left;
  }

  &__flexbox {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    padding: 0 2.5rem;
  }

  @include atS {
    margin-right: -45px;
    margin-left: -45px;
    padding-top: 6rem;
    padding-bottom: 6rem;

    &__flexbox {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 1.9rem;
      max-width: 100rem;
      margin: auto;
      padding: 0;
    }

    &__title {
      @include h5;
      padding-bottom: 7.2rem;
      text-align: center;
    }
  }

  @include atM {
    margin-right: auto;
    margin-left: auto;

    &__flexbox {
      max-width: 136rem;
    }
  }
}
</style>
